module.exports = __webpack_public_path__ + "static/media/cerveja-me-3.bd5ddbd4.jpg";